import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import SketchedLogoSpinner from '../Spinner/Spinner';

/*
This is a replication of Stripe's pricing card component that's styled
to match DeepKPI's design. It includes an optional confetti style
celebration that you can pass in. 

*/
export function PricingCard({ 
    productName,
    description,
    price, //e.g. "$100"
    cycle, //e.g. "month" or "year" for price info
    onPurchase, //Function to call when the user clicks the purchase button.
    isLoading, //Whether to show a loading spinner.
    error, //Error message to display if there's an error.
    confettiComponent, //optional.
    buttonText = "Start Trial",
    pricePreposition = "per" //Text to show before the cycle (e.g. "per" month or "for" month)
}) {
    return (
        <div 
            className="rounded-lg shadow-lg p-6" 
            style={{ 
                width: '250px', 
                margin: '0 auto',
                textAlign: 'left',
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: 'background.paper'
            }}
        >
            {confettiComponent && (
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden'
                }}>
                    {confettiComponent}
                </Box>
            )}
            <div style={{ position: 'relative', zIndex: 1 }}>
                <div>
                    <h2 className="text-2xl font-bold mb-4" style={{ textAlign: 'left', color: 'text.primary' }}>
                        {productName}
                    </h2>
                    
                    <p 
                        className="mb-6" 
                        style={{ 
                            wordWrap: 'break-word', 
                            lineHeight: 1.2, 
                            fontSize: '0.95rem',
                            textAlign: 'left',
                            color: 'text.secondary'
                        }}
                    >
                        {description}
                    </p>
                    
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px', 
                        marginBottom: '24px',
                        justifyContent: 'flex-start'
                    }}>
                        <Typography 
                            variant="h1" 
                            sx={{ 
                                fontSize: '2.5rem',
                                fontWeight: 800,
                                color: 'text.primary',
                                letterSpacing: '-0.02em',
                                WebkitFontSmoothing: 'antialiased',
                                MozOsxFontSmoothing: 'grayscale',
                                height: 'fit-content',
                                textAlign: 'left'
                            }}
                        >
                            {price}
                        </Typography>
                        
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'center', 
                            height: '100%',
                            textAlign: 'left'
                        }}>
                            <Typography 
                                variant="body2" 
                                sx={{ 
                                    color: 'text.secondary',
                                    lineHeight: 1,
                                    fontSize: '1.1rem',
                                    textAlign: 'left'
                                }}
                            >
                                {pricePreposition}
                            </Typography>
                            <Typography 
                                variant="body2" 
                                sx={{ 
                                    color: 'text.secondary',
                                    lineHeight: 1,
                                    fontSize: '1.1rem',
                                    textAlign: 'left'
                                }}
                            >
                                {cycle}
                            </Typography>
                        </div>
                    </div>
                    
                    <Button
                        variant="contained"
                        sx={{
                            width: '100%',
                            margin: '0 auto',
                            display: 'block',
                            backgroundColor: '#22d3ee',
                            boxShadow: '0 4px 12px rgba(34, 211, 238, 0.3)',
                            '&:hover': {
                                backgroundColor: 'rgb(103, 232, 249)',
                                boxShadow: '0 4px 20px rgba(34, 211, 238, 0.5)',
                            },
                            color: 'black',
                            textTransform: 'none',
                            fontSize: '1.125rem',
                            padding: '8px 12px',
                            height: '48px',
                        }}
                        onClick={onPurchase}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                <SketchedLogoSpinner size={42} />
                            </div>
                        ) : buttonText}
                    </Button>
                    {error && <div className="error-message">{error}</div>}
                </div>
            </div>
        </div>
    );
}

export default PricingCard; 